<template>
    <div>
        <load-screen-component/>
        <page-header title="Relatórios"></page-header>

        <div v-if="reports.length" class="row gutters">
            <div class="col-12 mb-3">
                <div class="card report-filter-card">
                    <div class="card-body py-3">
                        <div class="row gutters align-items-end">
                            <div class="col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12">
                                <label class="mb-2 font-weight-bold">Mês de referência</label>
                                <Select2
                                    v-model="selectedYearMonth"
                                    :options="reportMonthOptions"
                                    :settings="{ width: '100%' }"
                                    placeholder="Selecione"
                                />
                            </div>
                            <div class="col-xl-5 col-lg-7 col-md-6 col-sm-12 col-12 mt-sm-3 mt-md-0">
                                <label class="mb-2 font-weight-bold">Empresa</label>
                                <div class="input-group">
                                    <input
                                        v-model="companySearch"
                                        type="text"
                                        class="form-control"
                                        placeholder="Digite o nome da empresa"
                                    >
                                    <div class="input-group-append">
                                        <button
                                            type="button"
                                            class="btn btn-outline-secondary"
                                            :disabled="companySearch === ''"
                                            @click="clearCompanySearch"
                                        >
                                            Limpar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="selectedReport" class="col-12">
                <div class="card report-month-card">
                    <div class="card-body">
                        <div class="d-flex flex-wrap justify-content-between align-items-start report-month-header">
                            <div>
                                <div class="report-icon-wrapper bg-primary-light">
                                    <i class="icon-assignment report-icon"></i>
                                </div>
                                <h4 class="mt-3 mb-1">Relatórios de {{ selectedReport.label }}</h4>
                                <p class="text-muted mb-0">Links gerados para a rodada mensal de relatórios.</p>
                            </div>

                            <div class="report-actions mt-2">
                                <a
                                    v-if="selectedReport.all_companies_report?.url || selectedReport.all_companies_report?.fallback_url"
                                    :href="selectedReport.all_companies_report.url || selectedReport.all_companies_report.fallback_url"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="btn btn-outline-primary report-action-btn"
                                    title="Abrir relatório de todas as empresas"
                                    aria-label="Abrir relatório de todas as empresas"
                                >
                                    <i class="icon-eye1"></i>
                                </a>
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary report-action-btn"
                                    data-toggle="modal"
                                    data-target="#reportResendModal"
                                    title="Reenviar relatório de todas as empresas"
                                    aria-label="Reenviar relatório de todas as empresas"
                                    @click="openResendModal('all_companies', null)"
                                >
                                    <i class="icon-forward"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary report-action-btn"
                                    data-toggle="modal"
                                    data-target="#customModalTwo"
                                    title="Ver histórico de envios de todas as empresas"
                                    aria-label="Ver histórico de envios de todas as empresas"
                                    @click="openDispatchModal('all_companies', null, `Todas as empresas - ${selectedReport.label}`)"
                                >
                                    <i class="icon-message"></i>
                                </button>
                            </div>
                        </div>

                        <div class="report-summary-row mt-3">
                            <span class="badge badge-light mr-2">Envios: {{ selectedReport.all_companies_report?.dispatch_summary?.total || 0 }}</span>
                            <span class="badge badge-success mr-2">Sucessos: {{ selectedReport.all_companies_report?.dispatch_summary?.success || 0 }}</span>
                            <span class="badge badge-danger">Falhas: {{ selectedReport.all_companies_report?.dispatch_summary?.failure || 0 }}</span>
                        </div>

                        <div class="table-responsive mt-4">
                            <table class="table table-hover table-bordered mb-0">
                                <thead>
                                <tr>
                                    <th>Empresa</th>
                                    <th class="text-center report-link-column">Relatório</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="company in filteredCompanies" :key="`${selectedReport.year_month}-${company.company_id}`">
                                    <td>{{ company.company_name }}</td>
                                    <td class="text-center">
                                        <div class="report-actions justify-content-center">
                                            <a
                                                v-if="company.report?.url"
                                                :href="company.report.url"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                class="btn btn-outline-primary btn-sm report-action-btn"
                                                title="Abrir relatório"
                                                aria-label="Abrir relatório"
                                            >
                                                <i class="icon-eye1"></i>
                                            </a>
                                            <a
                                                v-else-if="company.report?.fallback_url"
                                                :href="company.report.fallback_url"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                class="btn btn-outline-secondary btn-sm report-action-btn"
                                                title="Abrir relatório fallback"
                                                aria-label="Abrir relatório fallback"
                                            >
                                                <i class="icon-eye1"></i>
                                            </a>
                                            <span v-else class="text-muted">Indisponível</span>
                                            <button
                                                type="button"
                                                class="btn btn-outline-secondary btn-sm report-action-btn"
                                                data-toggle="modal"
                                                data-target="#reportResendModal"
                                                title="Reenviar relatório"
                                                aria-label="Reenviar relatório"
                                                @click="openResendModal('company', company.company_id)"
                                            >
                                                <i class="icon-forward"></i>
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-outline-secondary btn-sm report-action-btn"
                                                data-toggle="modal"
                                                data-target="#customModalTwo"
                                                title="Ver histórico de envios"
                                                aria-label="Ver histórico de envios"
                                                @click="openDispatchModal('company', company.company_id, company.company_name)"
                                            >
                                                <i class="icon-message"></i>
                                            </button>
                                        </div>
                                        <div class="small text-muted mt-1">
                                            {{ company.report?.dispatch_summary?.success || 0 }}/{{ company.report?.dispatch_summary?.total || 0 }} sucessos
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="!filteredCompanies.length">
                                    <td colspan="2" class="text-center text-muted py-4">Nenhuma empresa encontrada para o filtro informado.</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="card report-empty-card">
            <div class="card-body text-center py-5">
                <i class="icon-assignment report-empty-icon"></i>
                <h4 class="mt-3">Nenhum relatório mensal encontrado</h4>
                <p class="text-muted mb-0">Quando as rodadas mensais forem geradas, os links aparecerão aqui para administração.</p>
            </div>
        </div>

        <modal-component :title-modal="titleModal" modalLarge @close="closeDispatchModal">
            <template #title>{{ titleModal }}</template>
            <div class="modal-body">
                <div v-if="dispatchHistory.length" class="table-responsive">
                    <table class="table table-hover table-bordered mb-0">
                        <thead>
                        <tr>
                            <th>Data/Hora</th>
                            <th>Número</th>
                            <th>Status</th>
                            <th>Mensagem</th>
                            <th>Erro</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="dispatch in dispatchHistory" :key="dispatch.id">
                            <td>{{ dispatch.attempted_at || '-' }}</td>
                            <td>{{ dispatch.recipient_number || '-' }}</td>
                            <td>
                                <span :class="dispatch.success ? 'badge badge-success' : 'badge badge-danger'">
                                    {{ dispatch.success ? 'Sucesso' : 'Falha' }}
                                </span>
                            </td>
                            <td>{{ dispatch.response_message || '-' }}</td>
                            <td>{{ dispatch.error_message || '-' }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="text-center py-4 text-muted">
                    Nenhum envio registrado para este relatório.
                </div>
            </div>
        </modal-component>

        <modal-component id-modal="reportResendModal" :title-modal="resendModal.title" modalLarge @close="closeResendModal">
            <template #title>{{ resendModal.title }}</template>
            <div class="modal-body">
                <div v-if="resendModal.loading" class="text-center py-4 text-muted">
                    Carregando dados do reenvio...
                </div>
                <div v-else-if="resendModal.data">
                    <div class="report-resend-card">
                        <div class="row gutters">
                            <div class="col-md-6 col-12 mb-3">
                                <p class="report-resend-label mb-1">Escopo</p>
                                <p class="mb-0">{{ resendModal.data.company_name }}</p>
                            </div>
                            <div class="col-md-6 col-12 mb-3">
                                <p class="report-resend-label mb-1">Mês de referência</p>
                                <p class="mb-0">{{ resendModal.data.label }}</p>
                            </div>
                            <div class="col-12 mb-3">
                                <p class="report-resend-label mb-1">Telefones que receberão o reenvio</p>
                                <div v-if="resendModal.data.recipient_numbers.length" class="report-phone-list">
                                    <span v-for="(number, key) in resendModal.data.recipient_numbers" :key="`recipient-${key}`" class="badge badge-light mr-2 mb-2">
                                        {{ number }}
                                    </span>
                                </div>
                                <p v-else class="text-danger mb-0">Nenhum telefone configurado para este reenvio.</p>
                            </div>
                            <div class="col-12">
                                <p class="report-resend-label mb-1">Link do relatório</p>
                                <a :href="resendModal.data.report_url" target="_blank" rel="noopener noreferrer" class="report-url-link">
                                    {{ resendModal.data.report_url }}
                                </a>
                            </div>
                        </div>
                    </div>
                    <p class="text-muted mt-3 mb-0">
                        Confirme os dados acima antes de reenviar a mensagem via WhatsApp.
                    </p>
                </div>
                <div v-else class="text-center py-4 text-muted">
                    Não foi possível carregar os dados para reenvio.
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeResendModal">Fechar</button>
                <button
                    type="button"
                    class="btn btn-primary"
                    :disabled="resendModal.loading || resendModal.submitting || !canConfirmResend"
                    @click="confirmResend"
                >
                    {{ resendModal.submitting ? 'Reenviando...' : 'Confirmar reenvio' }}
                </button>
            </div>
        </modal-component>
    </div>
</template>

<script>
import loadScreenComponent from '../../components/layouts/loadScreenComponent';
import pageHeader from '../../components/layouts/pageHeader';
import {http} from '../../services/config';
import errorMsg from '../../locales/errorMsg';
import Toast from '../../Helpers/Toast';
import Select2 from 'vue3-select2-component';
import modalComponent from '../../components/layouts/modalComponent';

export default {
    name: 'reportsIndex',
    components: {
        loadScreenComponent,
        pageHeader,
        Select2,
        modalComponent,
    },
    data() {
        return {
            reports: [],
            selectedYearMonth: null,
            companySearch: '',
            dispatchHistory: [],
            titleModal: '',
            resendModal: {
                title: '',
                loading: false,
                submitting: false,
                data: null,
            },
        };
    },
    computed: {
        reportMonthOptions() {
            return this.reports.map((report) => ({
                id: report.year_month,
                text: report.label,
            }));
        },
        selectedReport() {
            return this.reports.find((report) => report.year_month === this.selectedYearMonth) || this.reports[0] || null;
        },
        filteredCompanies() {
            if (!this.selectedReport) {
                return [];
            }

            const search = this.normalizeText(this.companySearch);
            if (search === '') {
                return this.selectedReport.companies;
            }

            return this.selectedReport.companies.filter((company) =>
                this.normalizeText(company.company_name).includes(search)
            );
        },
        canConfirmResend() {
            return Boolean(this.resendModal.data && this.resendModal.data.recipient_numbers?.length);
        },
    },
    mounted() {
        const email = localStorage.getItem('mail');
        const allowedEmails = [
            'r2soft@r2soft.com.br',
            'ricardo@r2soft.com.br',
            'tiago@r2soft.com.br',
            'lucinei@r2soft.com.br',
            'financeiro@r2soft.com.br',
        ];

        if (!allowedEmails.includes(email)) {
            this.$router.push({name: 'Home'});
            return;
        }

        this.loadReports();
    },
    methods: {
        closeDispatchModal() {
            this.dispatchHistory = [];
            this.titleModal = '';
        },
        closeResendModal() {
            this.resendModal = {
                title: '',
                loading: false,
                submitting: false,
                data: null,
            };
        },
        dismissResendModal() {
            document.querySelector('#reportResendModal .closeX')?.click();
        },
        clearCompanySearch() {
            this.companySearch = '';
        },
        normalizeText(value) {
            return (value || '')
                .toString()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .trim()
                .toLowerCase();
        },
        openResendModal(reportScope, companyId) {
            if (!this.selectedReport) {
                return;
            }

            this.closeResendModal();
            this.resendModal.title = reportScope === 'all_companies'
                ? `Reenviar relatório - Todas as empresas - ${this.selectedReport.label}`
                : 'Reenviar relatório';
            this.resendModal.loading = true;
            this.$store.commit('changeLoading', true);
            http.get('v1/companhias/relatorios-mensais/reenvio', {
                params: {
                    year_month: this.selectedReport.year_month,
                    report_scope: reportScope,
                    company_id: companyId,
                },
            }).then((resp) => {
                this.resendModal.data = resp?.data?.data || null;
                if (reportScope === 'company' && this.resendModal.data) {
                    this.resendModal.title = `Reenviar relatório - ${this.resendModal.data.company_name}`;
                }
                this.resendModal.loading = false;
                this.$store.commit('changeLoading', false);
            }).catch((err) => {
                this.resendModal.loading = false;
                this.resendModal.data = null;
                this.$store.commit('changeLoading', false);
                errorMsg.errorMsg(err);
            });
        },
        openDispatchModal(reportScope, companyId, label) {
            if (!this.selectedReport) {
                return;
            }

            this.titleModal = `Histórico de envios - ${label}`;
            this.$store.commit('changeLoading', true);
            http.get('v1/companhias/relatorios-mensais/envios', {
                params: {
                    year_month: this.selectedReport.year_month,
                    report_scope: reportScope,
                    company_id: companyId,
                },
            }).then((resp) => {
                this.dispatchHistory = resp?.data?.data || [];
                this.$store.commit('changeLoading', false);
            }).catch((err) => {
                this.dispatchHistory = [];
                this.$store.commit('changeLoading', false);
                errorMsg.errorMsg(err);
            });
        },
        confirmResend() {
            if (!this.resendModal.data || !this.canConfirmResend) {
                return;
            }

            this.resendModal.submitting = true;
            this.$store.commit('changeLoading', true);
            http.post('v1/companhias/relatorios-mensais/reenvio', {
                year_month: this.resendModal.data.year_month,
                report_scope: this.resendModal.data.report_scope,
                company_id: this.resendModal.data.company_id,
            }).then(() => {
                this.resendModal.submitting = false;
                this.$store.commit('changeLoading', false);
                Toast.success('Reenvio solicitado com sucesso.');
                this.loadReports();
                this.dismissResendModal();
            }).catch((err) => {
                this.resendModal.submitting = false;
                this.$store.commit('changeLoading', false);
                errorMsg.errorMsg(err);
            });
        },
        loadReports() {
            this.$store.commit('changeLoading', true);
            http.get('v1/companhias/relatorios-mensais').then((resp) => {
                this.reports = resp?.data?.data || [];
                this.selectedYearMonth = this.reports[0]?.year_month || null;
                this.companySearch = '';
                this.$store.commit('changeLoading', false);
            }).catch((err) => {
                this.reports = [];
                this.selectedYearMonth = null;
                this.companySearch = '';
                this.$store.commit('changeLoading', false);
                errorMsg.errorMsg(err);
            });
        },
    },
};
</script>

<style scoped>
.report-month-card,
.report-empty-card,
.report-filter-card {
    border: 1px solid #e8edf4;
    box-shadow: 0 10px 30px rgba(17, 38, 146, 0.06);
    border-radius: 16px;
}

.report-month-header {
    gap: 16px;
}

.report-icon-wrapper {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.bg-primary-light {
    background: rgba(10, 58, 117, 0.12);
}

.bg-success-light {
    background: rgba(14, 94, 78, 0.12);
}

.report-icon {
    font-size: 24px;
    color: #0a3a75;
}

.report-link-column {
    width: 180px;
}

.report-empty-icon {
    font-size: 42px;
    color: #0a3a75;
}

.report-actions {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.report-action-btn {
    width: 36px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: 50%;
    transition: all 0.2s ease;
}

.report-action-btn i {
    font-size: 15px;
}

.report-action-btn.btn-outline-primary {
    color: #0a3a75;
    border-color: rgba(10, 58, 117, 0.18);
    background: rgba(10, 58, 117, 0.06);
}

.report-action-btn.btn-outline-primary:hover,
.report-action-btn.btn-outline-primary:focus {
    color: #ffffff;
    border-color: #0a3a75;
    background: #0a3a75;
}

.report-action-btn.btn-outline-secondary {
    color: #5f6b7a;
    border-color: rgba(95, 107, 122, 0.18);
    background: rgba(95, 107, 122, 0.08);
}

.report-action-btn.btn-outline-secondary:hover,
.report-action-btn.btn-outline-secondary:focus {
    color: #ffffff;
    border-color: #5f6b7a;
    background: #5f6b7a;
}

.report-resend-card {
    border: 1px solid #e8edf4;
    border-radius: 12px;
    padding: 16px;
    background: #f8fafc;
}

.report-resend-label {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #6c7a89;
    font-weight: 700;
}

.report-url-link {
    word-break: break-all;
}
</style>
